import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Familia from "../pages/familia/page";
import AgenteFinanciero from "../pages/agente-financiero/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/familia",
    element: <Familia />,
  },
  {
    path: "/agente-financiero",
    element: <AgenteFinanciero />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;